<template>
  <div class="d-flex justify-content-center align-items-center h-100 login-container">
    <div class="container">
      <div class="d-flex justify-content-center">
        <div class="w-90">
          <div class="rounded-0 overflow-hidden">
            <div class="row m-0 border-top-2xl border-ow-primary">
              <div class="col-md-12 p-0 bg-ow-secondary">
                <transition 
                  appear
                  enter-active-class="animate__animated animate__zoomIn"
                >
                  <div class="login-splash py-5 text-center">
                    <img src="/images/login-logo.png" alt="login" />
                  </div>
                </transition>
              </div>
              <div class="col-md-12 position-relative">
                <div class="position-absolute w-100 h-100 bg-ow-primary opacity-9 z-index-2 left-0 top-0"></div>
                <transition 
                  appear
                  enter-active-class="animate__animated animate__zoomIn"
                >
                  <div class="py-4 px-5 position-relative z-index-4">
                    <form class="form-horizontal" method="POST" action="/login">
                      <csrf-field></csrf-field>
                      <div class="form-group mb-4" :class="{'is-invalid': $errors.has('user_name')}">
                        <label for="email" class="control-label text-base text-white">
                          <b-icon icon="person" class="mr-2"></b-icon> Nombre de usuario
                        </label>
            
                        <div>
                          <input
                            id="userName"
                            type="text"
                            class="form-control border-0 rounded-0"
                            name="user_name"
                            :value="$oldInputs.get('user_name', '')"
                            required
                            autofocus
                            :class="{'is-invalid': $errors.has('user_name')}"
                          />
                          <span class="mt-2 d-block" v-if="$errors.has('user_name')">
                            <strong class="text-danger">*</strong> <span>{{ $errors.first('user_name') }}</span>
                          </span>
                        </div>
                      </div>
            
                      <div class="form-group mb-4" :class="{'is-invalid': $errors.has('password')}">
                        <label for="password" class="control-label text-base text-white">
                          <b-icon icon="key" class="mr-2"></b-icon> Contraseña
                        </label>
            
                        <div>
                          <input
                            id="password"
                            type="password"
                            class="form-control border-0 rounded-0"
                            name="password"
                            required
                          />
                          <span class="help-block" v-if="$errors.has('password')">
                            <strong>{{ $errors.first('password') }}</strong>
                          </span>
                        </div>
                      </div>
            
                      <div class="form-group mb-4">
                        <div >
                          <div class="checkbox">
                            <label class="text-white"><input type="checkbox" name="remember" :checkedvalue="$oldInputs.get('remember', '')" > Recuérdame</label>
                          </div>
                        </div>
                      </div>
            
                      <div class="form-group mb-0">
                        <div class="text-center">
                          <button type="submit" class="btn btn-ow-secondary">Iniciar sesión</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    
    }
  },
  mounted() {
    console.log(this.$errors.has('user_name'));
  },
  methods: {
  }
};
</script>
